

import { useEffect, useState } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import { toast } from "react-toastify";

const NewEmp = ({ item, onAddDepart }) => {
     const [departments, setDepartments] = useState([]);
    const [formData, setFormData] = useState({
        user_id: '',
        fname: '',
        department:'',
        code:'',
        type1:'user',
        fname:'',
        gender: 'Male',
        mobile: '',
        email:'',
        dob:'',
        doj:'',
        // fees:'',
        address_line1: '',
        type: 'employee',
       
        alertMsg: '',
        alertMsgTyp: '',
        isAlert: false,
    });
    const [ldata, setLdata] = useState(null);

    const handleChange = (e) => {

        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // alert(formData.email+"");
        const fd = new FormData();
        fd.append('user_id', formData.user_id);
        fd.append('fname', formData.fname);
        fd.append('department', formData.department);
        fd.append('code', formData.code);
        fd.append('type', "employee");
        fd.append('type1', "employee");
        fd.append('gender', formData.gender);
        fd.append('mobile', formData.mobile);
        fd.append('email', formData.email);
        fd.append('dob', formData.dob);
        fd.append('doj', formData.doj);
        // fd.append('fees', formData.fees);
        fd.append('address_line1', formData.address_line1);
        fd.append('user_cre_by', ldata.user_id);
      

        try {
            const response = await axios.post(AppConst.BASE_URL + AppConst.addUserUrl, fd, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.data.status) {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
                document.getElementById("closeBt45").click();
                onAddDepart();
            }
            else {
                setFormData(prev => ({
                    ...prev,
                    isAlert: true,
                    alertMsg: response.data.success,
                    alertMsgTyp: response.data.type,
                }));
            }
        } catch (error) {
            setFormData(prev => ({
                ...prev,
                isAlert: true,
                alertMsg: "Failed",
                alertMsgTyp: "danger",
            }));
        }

    };

    useEffect(() => {
        console.log('Component mounted');
        const storedData = sessionStorage.getItem("ldata");
        if (storedData) {
            const parsed = JSON.parse(storedData);
            setLdata(parsed);
        }

        if (item) {
            console.log("Editing item:", item);
            if (item != null && item != undefined) {
                setFormData(prev => ({
                    ...prev,
                    fname: item.fname,
                    user_cre_by: item.user_cre_by,
                    department: item.department,
                    code: item.code,
                    type: item.type,
                    type1: item.type1,
                    gender: item.gender,
                    mobile: item.mobile,
                    email: item.email,
                    dob: item.dob,
                    doj: item.doj,
                    // fees: item.fees,
                    address_line1: item.address_line1,
                    user_cre_by: item.user_cre_by,
                    user_id: item.user_id,
                }));

              
            }
        }
        else {
            setFormData(prev => ({
                ...prev,
                fname: "",
                user_cre_by: "",
                department: "",
                code: "",
                type1: "",
                gender:"",
                mobile: "",
                email:"",
                dob: "",
                doj: "",
                // fees: "",
                address_line1: "",
                user_cre_by: "",
                user_id: ""
            }));
        }

        return () => {
            console.log('Component unmounted');
        };
    }, [item]);

      const fetchRoles = async () => {
    try {
      const response = await axios.get(AppConst.BASE_URL + AppConst.GetAllRole);
      if (response.data.status) setDepartments(response.data.list);
    } catch (err) {
      toast.error("Error fetching roles");
    }
  };
  

    useEffect(() => {
      fetchRoles();
    }, []);

    return (
        <div class="modal fade" id="showModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">
                    <div class="modal-header bg-light p-3">
                        <h5 class="modal-title" id="exampleModalLabel">&nbsp;</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"></button>
                    </div>
                    <form class="tablelist-form" onSubmit={handleSubmit}>
                        <div class="modal-body">
                            <div class="row gy-4 mb-3">
                                <div class="col-md-6">
                                    <div id="modal-id">
                                        <label for="orderId" class="form-label">Department</label>
                                        <select
  value={formData.department}
  onChange={(e) => setFormData({ ...formData, department: e.target.value })}
  className="form-select mb-4"
  required
>
  <option value="">Select Department</option>
  {departments.map((dept) => (
    <option key={dept.id} value={dept.id}>
      {dept.role_name}
    </option>
  ))}
</select>


                                        
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                        <label for="customername-field" class="form-label">Employee Code</label>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <input class="form-control" name="code" onChange={handleChange} value={formData.code} data-provider="flatpickr" placeholder="Code" type="text" />
                                            </div>
                                            {/* <div class="col-md-7">
                                                <select class="form-control" name="type" onChange={handleChange} value={formData.type} data-trigger=""id="productname-field">
                                                    <option value="Driver">Driver</option>
                                                    <option value="Cleaner">Cleaner</option>
                                                </select>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-6">
                                    <div >
                                        <label for="date-field" class="form-label">Name</label>
                                        <input class="form-control" name="fname" onChange={handleChange} value={formData.fname} data-provider="flatpickr" placeholder="Name" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="date-field" class="form-label">Gender</label>
                                        <select class="form-control" name="gender" onChange={handleChange} value={formData.gender} data-trigger=""  id="productname-field">
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                            <option value="Other">Other</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                        <label for="amount-field" class="form-label">Mobile</label>
                                        <input id="amount-field" class="form-control" name="mobile" 
                                        onChange={handleChange} value={formData.mobile} placeholder="Mobile" type="text" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div>
                                        <label for="amount-field" class="form-label">Email Address</label>
                                        <input id="amount-field" class="form-control" name="email" onChange={handleChange} 
                                        value={formData.email} placeholder="Email Address" type="text" />
                                    </div>
                                </div>

                                {/* <div class="col-md-4">
                                    <div >
                                        <label for="date-field" class="form-label">Charge</label>
                                        <input class="form-control" name="fees" onChange={handleChange} value={formData.fees} data-provider="flatpickr" placeholder="Charge" type="text" />
                                    </div>
                                </div> */}
                                <div class="col-md-6">
                                    <div >
                                        <label for="date-field" class="form-label">DOB</label>
                                        <input class="form-control" name="dob" onChange={handleChange} value={formData.dob} data-provider="flatpickr" placeholder="DOB" type="date" />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div >
                                        <label for="date-field" class="form-label">DOJ</label>
                                        <input class="form-control" name="doj" onChange={handleChange} value={formData.doj} data-provider="flatpickr" placeholder="DOJ" type="date" />
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div >
                                        <label for="date-field" class="form-label">Address</label>
                                        <textarea class="form-control" name="address_line1" onChange={handleChange} value={formData.address_line1} data-provider="flatpickr"
                                            placeholder="Address" type="text" ></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <div class="hstack gap-2 justify-content-end">
                                <button type="button" id="closeBt45" class="btn btn-light" data-bs-dismiss="modal">Close</button>
                                {(formData.user_id.length > 0) ? <button type="submit" class="btn btn-success" id="edit-btn">Update</button> : <button type="submit" class="btn btn-success" id="edit-btn">Add</button>}

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default NewEmp;
